import { Component, OnInit, Input } from '@angular/core';
import { Logging } from '../../logging';
import { ApiService } from '../../shared/api-service/api.service';
import { AuthService } from '../../shared/auth/auth.service';

@Component({
  selector: 'app-main-dashrecent-list',
  templateUrl: './main-dashrecent-list.component.html',
  styleUrls: []
})
export class MainDashrecentListComponent implements OnInit {

  @Input() transtype:string;

  loading: boolean;
  translist: any;
  constructor(private api: ApiService,
    private auth: AuthService) { }

  ngOnInit() {

    Logging.log(this.transtype);
    this.getData();
  }


  getData()
  {
      this.loading = true;
     
      //Fetch all users
      this.api.get('/accounts/'+ this.auth.getAccountID() + '/transactions' + '?sort=transactiondate,desc&page=0&size=10&transtype=' + this.transtype)
      .subscribe(
        res_data => {
        Logging.log(res_data.data);
        this.translist = res_data.data.content;
        this.loading = false;
        }, error_message => {
          this.loading = false;
         //  this.hasError = true;
         //  this.errorMessage = error_message;
        }
      );
    }

    toAbs(amount : number) : number
    {
        return Math.abs(amount);
    }

}



// WEBPACK FOOTER //
// ./src/app/client/main-dashrecent-list/main-dashrecent-list.component.ts